// caseListThunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '@/lib/axios';
import { setSelectedSearch } from '../filters/filterSlice';

export const getCaseListCards = createAsyncThunk(
  'cases/getCaseListCards',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        '/get_case_list_cards/',
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const getSavedSearches = createAsyncThunk(
  "cases/getSavedSearches",
  async (userId: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosInstance.get(`/saved_searches/${userId}`, {
        headers: {
          Accept: "application/json",
        },
      });

      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getCaseList = createAsyncThunk(
  'cases/getCaseList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        '/get_case_lists/',
        {
          headers: {
            Accept: 'application/json',
          },
          // @ts-expect-error: 'meta' is not part of AxiosRequestConfig but is used for custom middleware
          meta: {
            skipLoader: true, // Skip loader for this request
          }
        }
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

